export default {
  getMvcCode: (state) => state.mvcCode,
};
